module.exports = __webpack_public_path__ + "images/backgrounds/red-sweater.17d3a6bc27bdcd05caea.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/red-sweater.png
// module id = EjGy
// module chunks = 2